export enum Formality {
    default = 'default',
    preferMore = 'preferMore',
    preferLess = 'preferLess',
}